import React, {useState, useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, NavLink,useLocation, useNavigate } from 'react-router-dom';
import Historia from './pages/Historia';
import Privacidad from './pages/Privacidad';
import Terminos from './pages/Terminos';
import ListaDeEspera from './pages/ListaDeEspera';
import Registrarse from './pages/Registrarse';
import Shop from './pages/Shop';
import Eventos from './pages/Eventos';
import Cai from './pages/Cai';
import WineAsAService from './pages/WineAsAService';
import Preguntas from './pages/Preguntas';
import Carrito from './pages/Carrito';
import LoginPage from './pages/Login';
import Perfil from './pages/Perfil';
import { signOut } from 'firebase/auth';
import { ReactComponent as ChartIcon } from './assets/icons/ChartIcon.svg';
import Demostraciones from './pages/Demostraciones';
import Degustaciones from './pages/Degustaciones';
import Reservas from './pages/Reservas';
import Cupo, { UIDS_CON_ACCESO_A_DEMO } from './pages/Cupo';
import PrivateRoute from './PrivateRoute';
import { AuthProvider, useAuth } from './contexts/AuthContext'; 
import { CartProvider, useCart } from './contexts/CartContext';
import { ToastProvider } from './contexts/ToastContext';
import {auth, db} from './firebaseConfig'
import {  doc, getDoc } from 'firebase/firestore';
import { ReactComponent as FincaIcon } from './assets/icons/FincaIcon.svg';
import { ReactComponent as Druida } from './assets/icons/Druida.svg';
import { ReactComponent as Etiquetas } from './assets/icons/etiquetas/etiquetas.svg';
import { ReactComponent as Etiqueta1 } from './assets/icons/etiquetas/etiqueta1.svg';
import { ReactComponent as Etiqueta2 } from './assets/icons/etiquetas/etiqueta2.svg';
import { ReactComponent as Etiqueta3 } from './assets/icons/etiquetas/etiqueta3.svg';
import { ReactComponent as Etiqueta4 } from './assets/icons/etiquetas/etiqueta4.svg';
import './App.css';
import LoadingSpinner from './assets/LoadingSpinner';
import { FEATURES } from './config/features';
function EnologoPopup({ onClose }) {
    const [isClosing, setIsClosing] = useState(false);
    const handleClose = () => {
        setIsClosing(true);
        setTimeout(onClose, 300);
    };
    return (
        <div className={`enologo-popup-backdrop${isClosing ? ' enologo-popup-closing' : ''}`} onClick={handleClose}>
            <div className={`enologo-popup-content${isClosing ? ' enologo-popup-closing' : ''}`} onClick={(e) => e.stopPropagation()}>
                <button className="enologo-popup-close" onClick={handleClose} aria-label="Cerrar">
                    <span></span>
                    <span></span>
                </button>
                <div className="enologo-popup-scroll">
                    <p>Hay oficios que se aprenden. Y hay oficios que, además, se heredan, se sienten y se honran.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>En cada botella de vino existe una historia que comenzó mucho antes de llegar a nuestras manos. Una historia que atraviesa generaciones, conocimientos, territorios y, sobre todo, personas.</p>
                    <p>Hace miles de años, la humanidad comenzó a transformar la uva en vino. Desde entonces, ese legado no se detuvo. Cambiaron las técnicas, los paisajes y las herramientas, pero permanece intacto algo esencial: la capacidad de una persona para interpretar la naturaleza y convertir sus frutos en una expresión única.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Ahí está el enólogo.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>El que observa, conoce, espera. El que entiende que no todo puede apresurarse y que cada cosecha tiene su propio lenguaje. El que combina ciencia y sensibilidad para encontrar el equilibrio, respetando aquello que la tierra ofrece y guiándolo hasta convertirse en vino.</p>
                    <p>En Finca Los Astros creemos profundamente en esa simbiosis invisible que hace posible el círculo perfecto: la tierra, la vid, el tiempo, el conocimiento y la persona.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Por eso, nuestro nombre es también un homenaje.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Un reconocimiento a quienes mantienen vivo ese legado milenario. A quienes ponen su conocimiento al servicio de la naturaleza. A quienes trabajan para que detrás de cada copa exista mucho más que un producto: exista identidad, dedicación, carácter y una historia que merece ser contada.</p>
                    <p>Porque un vino de excelencia no sucede por casualidad, sino por un conjunto de causalidades.</p>
                    <p>Por la tierra que lo recibe, por la vid que lo expresa, por el clima que lo acompaña, por el tiempo que lo transforma y, fundamentalmente, por las personas capaces de interpretar cada una de esas variables y encontrar entre ellas un equilibrio único.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Nada ocurre de manera aislada.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Existe una trama invisible de conocimiento, naturaleza, paciencia, intuición y oficio que, cuando encuentra su punto exacto, hace posible algo extraordinario: que una historia pueda beberse.</p>
                    <p>Hoy, en el Día del Enólogo, desde Finca Los Astros celebramos y agradecemos a quienes hacen de este antiguo oficio una expresión de conocimiento, pasión y humanidad.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>A quienes interpretan la tierra para convertirla en vino.</p>
                    <p>A quienes custodian un legado que sigue vivo.</p>
                    <p>A quienes hacen posible que cada botella encuentre su momento, su lugar y su historia.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Feliz Día del Enólogo.</p>
                    <p className="enologo-popup-blank">&nbsp;</p>
                    <p>Finca Los Astros</p>
                    <p>Donde la tierra, el tiempo y las personas encuentran su equilibrio.</p>
                </div>
                <div className="enologo-popup-fade"></div>
            </div>
        </div>
    );
}

function HomePage() {
    const { user } = useAuth();
    const listaDeEsperaPath = user ? "/perfil" : "/lista-de-espera";
    const ENOLOGO_POPUP_ACTIVO = false; // Popup del Dia del Enologo: desactivado tras la fecha, dejar el codigo por si se reusa
  const [showEnologoPopup, setShowEnologoPopup] = useState(false);
    useEffect(() => {
        if (!ENOLOGO_POPUP_ACTIVO) return;
        const timer = setTimeout(() => setShowEnologoPopup(true), 500);
        return () => clearTimeout(timer);
    }, []);
    return (
        <div className="home-page">
            {ENOLOGO_POPUP_ACTIVO && showEnologoPopup && <EnologoPopup onClose={() => setShowEnologoPopup(false)} />}
            {/* Contenedor del Acceso Miembros */}
            <div>
                <NavLink  className='home-access'  style={{textDecoration:'none'}} to="/acceso-miembros">
                    <h1 style={{cursor:'pointer'}}>Acceso Miembros</h1>
                </NavLink>
            </div>

            {/* Contenido Principal */}
            <div className="home-container">
                {/* Contenedor del logo/SVG: Uso de unidades responsivas para altura y margen */}
                <div style={{
                    height: '30vh', /* Altura responsiva basada en la ventana */
                    backgroundColor: '#a58d70',
                    width: 'fit-content',
                    margin: '0 auto 5vh' /* Margen responsivo basado en la ventana */
                }}>
                    {/* Estilos del SVG/Druida */}
                    <Druida style={{
                        fill: '#31173d',
                        height: '30vh', /* Mismo valor que el padre para el llenado */
                        overflow: 'visible',
                        width: 'auto',
                        margin: ' 0'
                    }}/>
                </div>

                {/* Contenedor de Navegación */}
                <div className="home-navlink-container notranslate" translate="no">
                    {/* ... Tus NavLinks ... */}
                    <NavLink to="/historia" className="home-navlink">Historia</NavLink>
                    <NavLink to={listaDeEsperaPath} className="home-navlink">Lista de espera</NavLink>
                    <NavLink to="/shop" className="home-navlink">Shop</NavLink>
                    {FEATURES.eventos && <NavLink to="/eventos" className="home-navlink">Eventos</NavLink>}
                    {FEATURES.wineAsAService && <NavLink to="/wine-as-a-service" className="home-navlink">Wine as a Service</NavLink>}
                    {FEATURES.cai && <NavLink to="/cai" className="home-navlink">Cai</NavLink>}
                    {FEATURES.preguntasFrecuentes && <NavLink to="/preguntas-frecuentes" className="home-navlink">Preguntas frecuentes</NavLink>}
                </div>

                {/* Etiquetas: título centrado y las cuatro etiquetas en fila */}
                <div className="home-etiquetas">
                    <Etiquetas className="home-etiquetas-titulo" />
                    <div className="home-etiquetas-row">
                        <Etiqueta1 className="home-etiqueta" />
                        <Etiqueta2 className="home-etiqueta" />
                        <Etiqueta3 className="home-etiqueta" />
                        <Etiqueta4 className="home-etiqueta" />
                    </div>
                </div>
            </div>

            {/* Pie de Página - Movido a clase 'copyright-container' */}
            <div className='copyright-container'>
                {/* Texto del Pie de Página - Movido a clase 'copyright-text' */}
                <p className='copyright-text'>
                    <span className="copyright-main">Finca Los Astros S.A.S. Valle de Uco, Mendoza</span>
                    <span className="copyright-separator"> | </span>
                    <span className="copyright-links">
                        <NavLink to="/politica-de-privacidad" className='copyright-text footer-link' style={{textDecoration:'none'}}>Política de Privacidad de Datos</NavLink>
                        {' | '}
                        <NavLink to="/terminos-y-condiciones" className='copyright-text footer-link' style={{textDecoration:'none'}}>Términos y Condiciones</NavLink>
                    </span>
                </p>
            </div>
        </div>
  );
}

// Shop es visible para cualquiera (anónimo, Registrado o miembro de la
// lista): a diferencia de Cupo asignado, no requiere estar logueado para
// navegar el catálogo — solo hace falta login para pagar en /carrito.
const publicLinks = [
{ to: "/historia", label: "Historia" },
{ to: "/lista-de-espera", label: "Lista de Espera" },
{ to: "/shop", label: "Shop" },
{ to: "/eventos", label: "Eventos", enabled: FEATURES.eventos },
{ to: "/wine-as-a-service", label: "Wine as a Service", enabled: FEATURES.wineAsAService },
{ to: "/cai", label: "CAI", enabled: FEATURES.cai },
{ to: "/preguntas-frecuentes", label: "Preguntas Frecuentes", enabled: FEATURES.preguntasFrecuentes },
].filter(link => link.enabled !== false);
const memberLinks = [
{ to: "/perfil", label: "Su Perfil" },
{ to: "/cupo-asignado", label: "Cupo asignado" },
{ to: "/shop", label: "Shop" },
{ to: "/eventos", label: "Eventos", enabled: FEATURES.eventos },
{ to: "/demostraciones", label: "Demostraciones", enabled: FEATURES.demostraciones },
{ to: "/degustaciones", label: "Catas", enabled: FEATURES.catas },
{ to: "/reservas", label: "Sus Reservas", enabled: FEATURES.reservas },
].filter(link => link.enabled !== false);
// Compartido entre MemberNavbar y PublicNavbar (ambos pueden mostrar el
// ícono de carrito, ya que Shop es visible para cualquiera).
const formatPrice = (price) => {
  return `AR$ ${new Intl.NumberFormat('es-AR', { maximumFractionDigits: 0 }).format(price)}`;
};
// Destello dorado del texto del carrito flotante al agregar algo. Escucha
// ultimoAgregado (un timestamp que solo cambia en addToCart) en vez de
// cartItems entero, para no disparar el destello al editar cantidades ya
// en el carrito o al sacar un ítem.
function useCartDestello() {
const { ultimoAgregado } = useCart();
const [destacado, setDestacado] = useState(false);
useEffect(() => {
if (!ultimoAgregado) return undefined;
setDestacado(true);
const timer = setTimeout(() => setDestacado(false), 700);
return () => clearTimeout(timer);
}, [ultimoAgregado]);
return destacado;
}
// Ícono del carrito compartido por ambas navbars (miembro y pública). Con el
// carrito vacío no hay nada que ver en /carrito, así que en vez de un
// NavLink se renderiza un <span> sin destino: no navega ni muestra cursor
// de link (ver .cart-icon-container-vacio en App.css).
function CartIconLink({ location, totalItems, totalCompra, destacadoCarrito, extraClassName }) {
const contenido = (
<>
<span className="cart-icon-wrapper">
<ChartIcon className="cart-bag-icon" style={{overflow:'visible'}}/>
{totalItems > 0 && (
<span className={destacadoCarrito ? 'cart-item-badge cart-item-badge-destello' : 'cart-item-badge'}>
{totalItems}
</span>
)}
</span>
<span className={destacadoCarrito ? 'cart-item-count cart-item-count-destello' : 'cart-item-count'}>
{totalItems} Ítem{totalItems > 1 || totalItems === 0 ? 's' : ''}
{totalItems > 0 && (
<span className="cart-item-count-monto"> / {formatPrice(totalCompra)}</span>
)}
</span>
</>
);
return (
<div className={`cart-icon-container${extraClassName ? ' ' + extraClassName : ''}${totalItems === 0 ? ' cart-icon-container-vacio' : ''}`}>
{totalItems > 0 ? (
<NavLink to="/carrito" state={{ from: location.pathname }} className="cart-link">
{contenido}
</NavLink>
) : (
<span className="cart-link" aria-disabled="true">
{contenido}
</span>
)}
</div>
);
}
function MemberNavbar({ user }) {
const { totalItems, totalCompra } = useCart();
const destacadoCarrito = useCartDestello();
const location = useLocation();
const navigate = useNavigate();
const [clientName, setClientName] = useState(null);
const [nombrePila, setNombrePila] = useState(null);
const [loadingName, setLoadingName] = useState(true);
const isCupoPage = location.pathname === '/cupo-asignado' || location.pathname === '/shop';
const estadoLista = user.profileData?.estadoLista;
// Excepción puntual: para Martín y Tomás, "Cupo asignado" no queda
// deshabilitado por el flag global (la tienda todavía no se lanzó para
// clientes reales, pero ellos necesitan poder entrar a revisarla).
const esEmpleadoConAcceso = UIDS_CON_ACCESO_A_DEMO.includes(user.uid);
const isCupoDisabled = !esEmpleadoConAcceso && (estadoLista === 'Espera' || !FEATURES.cupoHabilitado);
const reservas = user.profileData?.reservas || [];
  // 💡 NUEVO: Comprobar si las reservas están vacías
  const hasReservas = reservas.length > 0;
const DISABLED_COLOR = '#8e8e8e';
useEffect(() => {
if (user && user.uid) {
const fetchClientData = async () => {
let docSnap;
let userDataFound = false;
try {
let docRef = doc(db, 'clientes', user.uid);
docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const data = docSnap.data();
setClientName(`${data.titulo || ''} ${data.nombre || ''} ${data.apellido || ''}`);
setNombrePila(data.nombre || '');
userDataFound = true;
}
if (!userDataFound) {
docRef = doc(db, 'usuarios', user.uid);
docSnap = await getDoc(docRef);
if (docSnap.exists()) {
const data = docSnap.data();
setClientName(`${data.nombre || ''} ${data.apellido || ''}`);
setNombrePila(data.nombre || '');
userDataFound = true;
}
}
if (!userDataFound) {
console.log("No se encontró el documento en 'clientes' ni en 'usuarios'.");
setClientName(user.email.split('@')[0]);
setNombrePila(user.email.split('@')[0]);
}
} catch (error) {
console.error('Error al obtener datos del cliente:', error);
setClientName(user.email.split('@')[0]);
setNombrePila(user.email.split('@')[0]);
} finally {
setLoadingName(false);
}
};
fetchClientData();
}
}, [user]);
const handleLogout = async () => {
  try {
    await signOut(auth);
    navigate('/'); 
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
    console.log('Hubo un error al cerrar la sesión.'); 
  }
};
return (
<div>
<div className="navbar-container" style={{boxShadow:'inset 0 -1px 5px rgba(0, 0, 0, 0)'}}> 
<div className="navbar-logo">
<NavLink to="/" className="navbar-logo" style={{overflow:'visible', padding: 0, margin: 0, cursor:'pointer'}}> 
<FincaIcon alt='fincaicon' className="navbar-logo-icon" style={{overflow:'visible'}}/>

</NavLink> 
</div>
<div className="member-greeting">
<NavLink to="/perfil" style={{color:'#2d193b', fontSize:'14px', fontWeight:'100', textDecoration:'none'}} >
{}
<span className="member-greeting-completo">Bienvenido, {loadingName ? 'Miembro' : clientName || 'Miembro'}</span>
{}
<span className="member-greeting-corto">Bienvenido, {loadingName ? 'Miembro' : nombrePila || 'Miembro'}</span>
</NavLink>
</div>
{isCupoPage && (
<CartIconLink
location={location}
totalItems={totalItems}
totalCompra={totalCompra}
destacadoCarrito={destacadoCarrito}
/>
)}
<div className="navbar-access logout" >
<h1 onClick={handleLogout} >Cerrar Sesión</h1>
</div>
</div>
<nav className="user-navbar-links notranslate" translate="no">
{memberLinks.map((link) => {
const isReservasLink = link.to === '/reservas'; // 💡 NUEVO: Identificar el enlace de reservas

// La lógica para deshabilitar el cupo existente
const isCupoDisabledLocal = link.to === '/cupo-asignado' && isCupoDisabled;

// 💡 NUEVO: Condición para deshabilitar "Sus Reservas"
const isReservasDisabled = isReservasLink && !hasReservas;

// 💡 COMBINAR LAS CONDICIONES DE DESHABILITACIÓN
const isDisabled = isCupoDisabledLocal || isReservasDisabled;
if (isDisabled) {
return (
<span 
        key={link.to} 
        className="user-nav-link-member" 
        style={{ 
          cursor: 'not-allowed', 
          color: DISABLED_COLOR,
          opacity: 0.6
        }}
      >
        {link.label}
      </span>
    );
  }
  return (
    <NavLink 
      key={link.to}
      to={link.to} 
      className={({ isActive }) => isActive ? 'user-nav-active-member' : 'user-nav-link-member'}
    >
      {link.label}
    </NavLink>
  );
})}
</nav>
</div>
);
}
function PublicNavbar() {
const [isSidebarOpen, setIsSidebarOpen] = useState(false);
const location = useLocation();
const navigate = useNavigate();
const { user } = useAuth();
const { totalItems, totalCompra } = useCart();
const destacadoCarrito = useCartDestello();
const isShopPage = location.pathname === '/shop';
const handleLogout = async () => {
try {
await signOut(auth);
navigate('/');
} catch (error) {
console.error('Error al cerrar sesión:', error);
}
};

// Cerrar el sidebar al navegar a otra página
useEffect(() => {
setIsSidebarOpen(false);
}, [location.pathname]);

// Bloquear el scroll del body mientras el sidebar está abierto
useEffect(() => {
if (!isSidebarOpen) return undefined;
const previousOverflow = document.body.style.overflow;
document.body.style.overflow = 'hidden';
return () => { document.body.style.overflow = previousOverflow; };
}, [isSidebarOpen]);

return (
<div className="navbar-container navbar-public">
<button
type="button"
className="navbar-burger"
aria-label="Abrir menú"
aria-expanded={isSidebarOpen}
onClick={() => setIsSidebarOpen(true)}
>
<span /><span /><span />
</button>
<div className="navbar-logo" style={{overflow:'visible'}}>
<NavLink to="/" className="navbar-logo" style={{overflow:'visible', padding: 0, margin: 0, cursor:'pointer'}}>
<FincaIcon alt='fincaicon' className="navbar-logo-icon" style={{overflow:'visible'}}/>
</NavLink>
</div>
<nav className="navbar-links notranslate" translate="no">
{user && (
<NavLink
to="/perfil"
className={({ isActive }) => isActive ? 'nav-active' : 'nav-link'}
>
Mi Perfil
</NavLink>
)}
{publicLinks.map((link) => (
<NavLink
key={link.to}
to={link.to}
className={({ isActive }) => isActive ? 'nav-active' : 'nav-link'}
>
{link.label}
</NavLink>
))}
</nav>
{user ? (
<div className="navbar-access logout">
<h1 onClick={handleLogout}>Cerrar Sesión</h1>
</div>
) : (
<div className="navbar-access">
<NavLink style={{textDecoration:'none'}} to="/acceso-miembros" className={({ isActive }) => isActive ? 'nav-active-access' : undefined}>
<h1>Acceso Miembros</h1>
</NavLink>
</div>
)}
{isShopPage && (
<CartIconLink
location={location}
totalItems={totalItems}
totalCompra={totalCompra}
destacadoCarrito={destacadoCarrito}
extraClassName="cart-icon-container-registrado"
/>
)}

{/* Sidebar mobile: se despliega desde la izquierda */}
<div
className={`navbar-sidebar-overlay${isSidebarOpen ? ' open' : ''}`}
onClick={() => setIsSidebarOpen(false)}
/>
<aside className={`navbar-sidebar${isSidebarOpen ? ' open' : ''}`} aria-hidden={!isSidebarOpen}>
<button
type="button"
className="navbar-sidebar-close"
aria-label="Cerrar menú"
onClick={() => setIsSidebarOpen(false)}
>
×
</button>
<nav className="navbar-sidebar-links notranslate" translate="no">
{user && (
<NavLink
to="/perfil"
className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
>
Mi Perfil
</NavLink>
)}
{publicLinks.map((link) => (
<NavLink
key={link.to}
to={link.to}
className={({ isActive }) => isActive ? 'sidebar-link active' : 'sidebar-link'}
>
{link.label}
</NavLink>
))}
</nav>
</aside>
</div>
);
}
function Navbar() {
const { user, loading } = useAuth();
if (loading) {
return (
<LoadingSpinner />
);
}
// Un usuario 'Registrado' (logueado, todavía no está en la lista de espera)
// ve el navbar público de siempre — que ya incluye Shop — en vez del de
// miembro, porque no tiene Cupo asignado ni el resto de las secciones que
// dependen de estar en la lista.
if (user && user.profileData?.estadoLista === 'Registrado') {
return <PublicNavbar />;
}
return user ? <MemberNavbar user={user} /> : <PublicNavbar />;
}
function ConditionalNavbar() {
const location = useLocation();
const routesWithoutNavbar = ['/acceso-miembros', '/', '/politica-de-privacidad', '/terminos-y-condiciones'];
const shouldHideNavbar = routesWithoutNavbar.includes(location.pathname);
if (shouldHideNavbar) {
return null;
}
return <Navbar />;
}
function AppLayout() {
const location = useLocation();
const routesWithoutUI = ['/acceso-miembros', '/'];
const shouldHideUI = routesWithoutUI.includes(location.pathname);
useEffect(() => {
  const path = location.pathname;
  let bg = '#ffffff';
  if (path === '/') bg = '#2d193b';
  else if (path === '/acceso-miembros') bg = '#a58d70';
  document.body.style.backgroundColor = bg;
  document.documentElement.style.backgroundColor = bg;
}, [location.pathname]);
return (
<>
<ConditionalNavbar /> 
<div className="main-content-wrapper">
<Routes>
  {}
  <Route path="/" element={<HomePage />} />
  <Route path="/historia" element={<Historia />} />
  <Route path="/politica-de-privacidad" element={<Privacidad />} />
  <Route path="/terminos-y-condiciones" element={<Terminos />} />
  <Route path="/lista-de-espera" element={<ListaDeEspera />} />
  <Route path="/registrarse" element={<Registrarse />} />
  <Route path="/shop" element={<Shop />} />
  <Route path="/wine-as-a-service" element={<WineAsAService />} />
  <Route path="/cai" element={<Cai />} />
  <Route path="/preguntas-frecuentes" element={<Preguntas />} />
  <Route path="/eventos" element={<Eventos />} />
  <Route path="/acceso-miembros" element={<LoginPage />} />
  <Route path="/perfil" element={<PrivateRoute element={<Perfil />} />} />
  <Route path="/cupo-asignado" element={<PrivateRoute element={<Cupo />} />} />
  <Route path="/degustaciones" element={<PrivateRoute element={<Degustaciones />} />} />
  <Route path="/demostraciones" element={<PrivateRoute element={<Demostraciones />} />} />
  <Route path="/reservas" element={<PrivateRoute element={<Reservas />} />} />
<Route path="/carrito" element={<PrivateRoute element={<Carrito />} />} /> {}
  <Route path="*" element={<Navigate to={auth.currentUser ? "/perfil" : "/historia"} />} />
</Routes>
</div>
{}
{!shouldHideUI && <div className="gradient-overlay-bottom"></div>}
</>
);
}
function App() {
return (
<AuthProvider>
<Router>
<ToastProvider>
<CartProvider>
<AppLayout />
</CartProvider>
</ToastProvider>
</Router>
</AuthProvider>
);
}
export default App;
